import React from 'react';

const ConversionExplanationScientificNotationToAll = ({ conversionType, fromUnit, toUnit, inputValue, result, darkMode }) => {
  return (
    <div className={`p-4 ${darkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'}`}>
      <h3 className="text-xl font-bold mb-4">Scientific Notation to {toUnit} Conversion Explanation</h3>
      <p>The explanation for converting from Scientific Notation to {toUnit} is not available yet.</p>
      <p>Input: {inputValue} {fromUnit}</p>
      <p>Result: {result} {toUnit}</p>
    </div>
  );
};

export default ConversionExplanationScientificNotationToAll;